<template>
  <div class="home_page">
    <div class="logo w1200"><img
        src="../../static/img/home_logo.png"
        alt=""
      ></div>
    <nav class="navList">
      <ul class="w1200">
        <li
          v-for="(item, i) in navData"
          :key="i"
          :class="{ nav_li : active === i }"
          @click="gonav(item, i)"
        >
          {{item.name}}
        </li>
      </ul>
    </nav>
    <div class="container">
      <template v-if="$route.meta.keepAlive">
          <keep-alive>
              <router-view></router-view>
          </keep-alive>
      </template>
      <template v-else>
          <router-view></router-view>
      </template>
      <!-- <router-view></router-view> -->
    </div>
    <footers></footers>
  </div>
</template>

<script>
import Footers from "../components/Footer.vue";
export default {
  name: "home",
  components: {
    Footers
  },
  data() {
    return {
      active: 0,
      navData: [
        { name: "网站首页", path: "/home" },
        { name: "公司介绍", path: "/introduction" },
        // { name: "产品展示", path: "/product" },
        { name: "理赔服务", path: "/lpfw" },
        { name: "新闻动态", path: "/news" },
        { name: "合作伙伴", path: "/partner" },
        { name: "联系我们", path: "/contact" },
        { name: "信息披露", path: "/disclosure" }
      ]
    }
  },
  mounted() {
    this.active = sessionStorage.getItem("pages") - 0;
    this.bus.$on('pages', obj => {
      this.active = obj.pages - 0
    })
  },
  methods: {
    gonav(item, i) {
      sessionStorage.setItem("pages", i);
      this.$router.push({ path: item.path });
      this.active = sessionStorage.getItem("pages") - 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.navList {
  width: 100%;
  max-width: 1920px;
  height: 80px;
  background: #5182c4;
  margin: 0 auto;
  color: #e8f1f8;
  font-size: 26px;
  font-weight: 600;
  ul {
    display: flex;
    justify-content: space-between;
    li {
      text-align: center;
      line-height: 80px;
      cursor: pointer;
      width: 170px;
    }
    .logo {
      width: 61px;
      height: 66px;
      margin-top: 7px;
    }
    .nav_li {
      background-color: #1860c2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Homepage.vue